import { Component, ComponentInterface, Element, h, Prop, VNode } from '@stencil/core';

import { isDefined, uniAddProp, UniTemplate } from '@uiwebkit/common';

@Component({ tag: 'uni-form' })
export class UniFormComponent implements ComponentInterface {

  @Element() el!: HTMLElement;

  @Prop({ reflect: true }) path: string;

  @Prop({ reflect: true }) all: boolean = false;

  @Prop({ reflect: true }) selector: string;

  @Prop({ reflect: true, mutable: true }) prop: string;

  @Prop({ reflect: true }) prevent: boolean = true;

  @Prop({ reflect: true }) stop: boolean = false;

  @Prop({ reflect: true }) only: boolean = false;

  connectedCallback(): void {
    if (isDefined(this.path)) {
      this.prop = 'state';
    }
  }

  render(): VNode {
    const { el, all, selector, prop, prevent, stop } = this;

    return UniTemplate(
      <form onSubmit={(event) => onFormSubmit(event, el, all, selector, prop, prevent, stop)}>
        {this.path ? <uni-store-set path={this.path} /> : null}
        <slot />
      </form>,
    );
  }
}

function onFormSubmit(event, el, all, selector, prop, prevent, stop) {
  const form = el.firstElementChild;
  const formData = new FormData(form);
  let formObj = {};

  formData.forEach((value, key) => formObj[key] = value);

  if (prop) {
    uniAddProp(form, prop, formObj, all, selector);
  }

  if (stop) {
    event.stopPropagation();
  }

  if (prevent) {
    event.preventDefault();
  }
}
